const ensure = (value?: string): string => {
  if (!value) throw new Error("Missing env variable");
  return value;
};

export const API_ENNDPOINT = ensure(process.env.REACT_APP_API_ENDPOINT);
